import { Feature } from '@tencent/workbench';
import BaseToolbarFeature from '@src/framework/workbench/common/feature/base-toolbar-feature';
import type { IAdjustSlideFeature } from './adjust-slide-interface';
import { config, ADJUST_SLIDE_CONFIG } from './config';
import { canvasToPt, ptToCanvas } from '@src/slide/infrastructure/module/independent/unit';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import { TOOLBAR_REPORT_MAP } from '@src/framework/workbench/middleware/report';

@Feature()
export class AdjustSlideFeature extends BaseToolbarFeature implements IAdjustSlideFeature {
    public id = config.id;
    public config = config;
    public constructor() {
        super();
    }

    public handleSlideSizeChange(id: number) {
        const scale = parseFloat(String(canvasToPt(id / 100)));
        this.getAppService()
            .viewableServiceLayer.editAreaCanvasSizeManager.setCanvasScaleAndIsAutoAdapter(scale, false);
        window.dispatchEvent(new CustomEvent('resize', { detail: { countSizeAgain: true } })); // 主动触发window resize
        this.report(id);
    }

    public shouldCheck(name: string): boolean {
        let scale = ptToCanvas(this.getAppService().viewableServiceLayer.editAreaCanvasSizeManager.getCanvasScale());
        scale = Math.round(Number(scale.toFixed(2)) * 100);
        const scaleInfo = `${scale}%`;
        return ADJUST_SLIDE_CONFIG.find(item => item.content === scaleInfo)?.name === name;
    }

    private report(id: number) {
        tdw({
            ...TOOLBAR_REPORT_MAP[this.config.id](),
            ver5: id,
        });
    }
}
